import React from 'react'
import IncidentPerAttribute from './IncidentPerAttribute'


const ValidIncidentsPerDisability
 = () => {

    const monitorReport = false;

    return (
        <>
            <IncidentPerAttribute monitorReport={monitorReport} attributeType ="DISABILITYTYPEVICTIM" disaggregation = "sex"/>
        </>
    
  )
}

export default ValidIncidentsPerDisability
